var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-search.9b717fb1.png","uri@2x": __webpack_public_path__ + "icon-search.d9973303.png","uri@3x": __webpack_public_path__ + "icon-search.fa39fadd.png",
    width: 51,
    height: 51
});